module.exports = __webpack_public_path__ + "static/media/round-wc-24-px.54aeb17f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/svg/round-wc-24-px.svg
// module id = 771
// module chunks = 0